import * as React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from "react-i18next";

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import {toRem} from "../../themes/utils";

import {Link as MUILink} from '@mui/material';

const Header = () => {

    const { t } = useTranslation('common');

    return (
        <AppBar className="header" position="static" sx={{
            display: "flex",
            backgroundColor: "common.white",
            position: "fixed",
            alignItems: "center",
            flexFlow: "row wrap",
            justifyContent: "flex-start",
            padding: toRem(16),
            color: "text.primary",
            zIndex: 2
        }}>
            <Container maxWidth={false}>
                <Toolbar disableGutters>
                    <Grid container>
                        <Grid item xs={8}>
                            <Stack direction={{xs: "column", sm: "row"}}>
                                <Box component={Link} to="/" sx={{marginRight: {xs: "0%", sm: "5%", md: "10%"}}}>
                                    <Box component="img" src="/icon/logo-prowin-international.svg" alt="prowin-logo"
                                         sx={{height: {xs: toRem(32), sm: toRem(48)}}}/>
                                </Box>
                                <Typography variant="h4">{t("sales_partner_application")}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={2} display="flex" alignItems="center">
                            <MUILink component={Link} underline="hover" color="inherit" to="/blacklist">Email-Blacklist</MUILink>
                        </Grid>
                        <Grid item xs={2} display="flex" alignItems="center">
                            <MUILink underline="hover" color="inherit" href="https://projira.prowin.net/servicedesk/customer/portals" target="_blank" rel="noopener">IT Service Desk</MUILink>
                        </Grid>
                    </Grid>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
